export type Faq = {
  question: string
  answer: string
}

export type FaqGroup = {
  title: string
  faqs: Faq[]
}

export const faqGroups: FaqGroup[] = [
  {
    title: 'Choosing a California Mesothelioma Lawyer',
    faqs: [
      {
        question: 'Who is the best mesothelioma lawyer in California?',
        answer:
          'The best mesothelioma lawyers in California have decades of specific experience with asbestos litigation, a proven track record of multi-million dollar settlements, and operate on a contingency fee basis. California Mesothelioma Claims is widely recognized as a top-tier firm in California due to our specialized focus, extensive resources, and history of securing record verdicts for asbestos victims across the state.',
      },
      {
        question: 'How much does a mesothelioma lawyer cost?',
        answer:
          'Nothing upfront. California mesothelioma attorneys work on a contingency fee basis, meaning we are paid a percentage of your recovery only if we win. There are no hourly bills, no retainers, and no out-of-pocket costs. If we do not recover money for you, you owe us nothing.',
      },
      {
        question: 'What happens after I contact a mesothelioma lawyer?',
        answer:
          'Your first call is a free, confidential case review — usually 15 to 30 minutes. We ask about your diagnosis and work history, then our investigators begin tracing your asbestos exposure using employment records, product identification databases, and military service records. We handle the filing, negotiation, and litigation. In most cases you can complete the entire process from home, and we can travel to you.',
      },
      {
        question:
          'What is the statute of limitations for mesothelioma in California?',
        answer:
          'In California, the statute of limitations for a mesothelioma personal injury lawsuit is generally one year from the date of diagnosis, or one year from when the patient should reasonably have known the illness was caused by asbestos exposure. For wrongful death claims, it is one year from the date of death. Because this window is short, it is critical to contact a lawyer immediately to preserve your rights.',
      },
    ],
  },
  {
    title: 'Understanding a California Mesothelioma Claim',
    faqs: [
      {
        question: "Can I sue if I don't know where I was exposed?",
        answer:
          'Yes. Most clients do not know exactly where or when they were exposed, because mesothelioma can take 20 to 50 years to develop. Identifying the source of exposure is our job, not yours. Using employment histories, union records, military service records, jobsite databases, and product identification files, our investigators can typically pinpoint the specific asbestos products and companies involved.',
      },
      {
        question: 'How far back can an asbestos investigation go?',
        answer:
          'Investigations routinely reach back to the 1940s and 1950s. Decades of asbestos litigation have produced extensive archives of jobsite records, product invoices, corporate documents, and sworn testimony from prior cases. Even if an employer closed long ago, these records often establish where and when asbestos-containing products were used.',
      },
      {
        question: 'What evidence is needed?',
        answer:
          'The core evidence is a confirmed medical diagnosis — pathology reports, imaging, and physician records — plus proof of asbestos exposure. Exposure evidence can include employment or union records, Social Security earnings history, military service records, coworker testimony, and product identification. You do not need to gather this yourself; we obtain it on your behalf.',
      },
      {
        question: 'Can I file a claim against multiple companies?',
        answer:
          'Yes, and most claims do. A typical worker was exposed to asbestos-containing products made by many different manufacturers and suppliers. California law allows you to pursue every liable company, and doing so is usually how the largest recoveries are built — combining defendant settlements with asbestos trust fund claims.',
      },
      {
        question:
          'What if the company responsible for my exposure no longer exists?',
        answer:
          'You can still recover compensation. Many asbestos manufacturers filed for bankruptcy and were required to set aside asbestos trust funds to pay current and future victims. Others were acquired, insured, or reorganized, and their successors or insurers remain liable. A closed business rarely ends a valid California mesothelioma claim.',
      },
      {
        question: 'What are asbestos trust funds?',
        answer:
          'Asbestos trust funds are court-supervised accounts created during the bankruptcies of asbestos manufacturers, holding an estimated $30+ billion collectively to compensate victims. Trust claims are filed separately from lawsuits, are generally resolved faster, and can be pursued alongside a lawsuit against companies that are still solvent.',
      },
      {
        question: 'Can veterans receive VA benefits?',
        answer:
          'Yes. Veterans — especially U.S. Navy personnel, shipyard workers, and those who served at California bases — make up a significant share of mesothelioma cases. Veterans may qualify for VA disability compensation, healthcare, and survivor benefits. Filing for VA benefits does not prevent you from also suing the asbestos product manufacturers, since claims are against those companies, not the military.',
      },
      {
        question: 'Can family members file a wrongful death claim?',
        answer:
          'Yes. If a loved one has died from mesothelioma, California law allows a spouse, domestic partner, children, or other qualifying heirs to file a wrongful death claim. Families may recover medical expenses, lost income and support, funeral costs, and damages for the loss of companionship. The claim must generally be filed within one year of the date of death.',
      },
      {
        question: 'Will I have to go to court?',
        answer:
          'Usually not. The vast majority of California mesothelioma cases settle out of court, often before trial begins. When testimony is required, it is typically a deposition that can be taken at your home or by video. We prepare every case as if it will be tried — which is precisely what drives higher settlements.',
      },
      {
        question: 'How long does a mesothelioma lawsuit take?',
        answer:
          'Most California mesothelioma claims resolve within 12 to 18 months, and some settle sooner. California grants trial preference to seriously ill plaintiffs, which can move a mesothelioma case to trial within 120 days of the request. Asbestos trust fund claims often pay out even faster, sometimes within a few months.',
      },
    ],
  },
]

export const allFaqs: Faq[] = faqGroups.flatMap((group) => group.faqs)
